import { Colors } from "../preset.constants";

export const cardPreset = {
    root: {
        color: Colors.CardHeaderColor,
    },
    shadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.05)',
}